export default {"src":"/_next/static/media/Footer_logo.13abbd1a.svg","height":116,"width":429,"blurWidth":0,"blurHeight":0};